import React from 'react'
import RolesTable from "./roles/RolesTable";
import RolesFunctionPage from "./roles-function/RolesFunctionPage";
import RolesDataPage from "./roles-data/RolesDataPage";
import _checkRoles from "../../../helpers/checkRole";

function SettingRolePage() {
    const innerHeight = window.innerHeight

    return <div className='SettingRolePage PageDefault position-relative'>
        <div className="PageHeading">
            <h1 className="PageTitle">Danh sách quyền</h1>
        </div>
        <div className="d-flex">
            <div className="w-50 pr-3">
                <div className="PageTable" style={{maxHeight: parseInt(innerHeight) - 150 + 'px', overflow: 'auto'}}>
                    <RolesTable/>
                </div>
            </div>
            <div className="w-50">
                {_checkRoles('menu.setting.role.function') && <RolesFunctionPage innerHeight={innerHeight}/>}
                {_checkRoles('menu.setting.role.data') && <RolesDataPage innerHeight={innerHeight}/>}
            </div>
        </div>
    </div>
}

export default SettingRolePage
